import { MapPinIcon } from 'core/components/Icons'
import { Column, Table } from 'core/components/ui/Table'
import React from 'react'
import { PresenceRow } from '../../../domain/entities/SalesReport'
import { SectionCard } from './SectionCard'

interface PresenceTableProps {
  rows: PresenceRow[]
  loading?: boolean
}

export const PresenceTable: React.FC<PresenceTableProps> = ({ rows, loading = false }) => {
  const columns: Column<PresenceRow>[] = [
    {
      key: 'month',
      label: 'Month',
      render: (row) => <span className="font-semibold text-text-primary">{row.month}</span>,
    },
    { key: 'districts', label: 'No. of Districts' },
    { key: 'blocks', label: 'No. of Blocks' },
    { key: 'outlets', label: 'No. of MCC / VLC / Retailer' },
    {
      key: 'farmers',
      label: 'No. of Farmers',
      render: (row) => <span className="font-bold text-text-primary">{row.farmers}</span>,
    },
  ]

  return (
    <SectionCard title="Ground Presence" subtitle="Geographic and network reach, month over month">
      <Table
        columns={columns}
        data={rows}
        loading={loading}
        emptyMessage="No presence records."
        emptyIcon={<MapPinIcon size={20} className="opacity-60" />}
      />
    </SectionCard>
  )
}
